export default "__VITE_ASSET__BvWRpZyd__"